@if (form) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="price-sheet-form">
    <nb-card [ngClass]="customNbCardClass" [nbSpinner]="loading">
      <nb-card-header>
        <div class="title">{{ title }}</div>
        <span class="close-btn" (click)="confirmClose()" style="position:absolute;right:20px;font-size:19px;cursor:pointer;">
          <i class="fa-light fa-x"></i>
        </span>
      </nb-card-header>
      <!-- FORM -->
      <nb-card-body>
        <div class="form-group">
          <!-- LABEL -->
          <div class="form-field">
            <label for="label">{{ 'Price sheet label' | translate }}</label>
            <input
              nbInput
              id="label"
              type="text"
              formControlName="label"
              fullWidth
              (blur)="autoSave('label')"
            >
          </div>

          <!-- Asset Type -->
          <div class="form-field">
            <label for="asset_type_name">{{ 'Asset type' | translate }}</label>
            <input
              nbInput
              id="asset_type_name"
              type="text"
              formControlName="asset_type_name"
              fullWidth
            >
          </div>

          <!-- Median price -->
          <div class="form-field">
            <label for="average_price">{{ 'Median price' | translate }} ({{ currency }})</label>
            <input
              nbInput
              id="average_price"
              type="number"
              formControlName="average_price"
              fullWidth
              (blur)="autoSave('average_price')"
            >
          </div>

          <!-- Min Price (only in edit mode) -->
          @if (priceSheet) {
            <div class="form-field">
              <label for="min_price">{{ 'Min price' | translate }} {{ '(optional)' | translate }}</label>
              <input
                nbInput
                id="min_price"
                type="number"
                formControlName="min_price"
                fullWidth
                (blur)="autoSave('min_price')"
              >
            </div>

            <!-- Max Price -->
            <div class="form-field">
              <label for="max_price">{{ 'Max price' | translate }} {{ '(optional)' | translate }}</label>
              <input
                nbInput
                id="max_price"
                type="number"
                formControlName="max_price"
                fullWidth
                (blur)="autoSave('max_price')"
              >
            </div>
          }

          <!-- Quantity -->
          <div class="form-field">
            <label for="quantity">
              {{ 'Quantity' | translate }}
              (@if (quantityUnit) {{{ quantityUnit.name }}} @else {{{ "unit" | translate }}})
            </label>
            <input
              nbInput
              id="quantity"
              type="number"
              formControlName="quantity"
              fullWidth
              (blur)="autoSave('quantity')"
            >
          </div>

          <!-- Investment Type -->
          <div class="form-field" [nbSpinner]="(investmentTypes$ | async) === null">
            <label for="investment_type">{{ 'Investment type' | translate }}</label>
            <nb-select
              id="investment_type"
              formControlName="investment_type"
              placeholder="-"
              fullWidth
              (selectedChange)="autoSave('investment_type')"
              >
              @for (t of (investmentTypes$ | async); track t) {
                <nb-option [value]="t.id">
                  {{ t.name }}
                </nb-option>
              }
            </nb-select>
          </div>

          <!-- Budget scope -->
          <div class="form-field" [nbSpinner]="(budgetScopes$ | async)?.loading">
            <label for="budget_scope">{{ 'Budget scope' | translate }}</label>
            <nb-select
              id="budget_scope"
              formControlName="budget_scope"
              placeholder="-"
              fullWidth
              (selectedChange)="autoSave('budget_scope')"
              >
              @for (p of (budgetScopes$ | async)?.data; track p) {
                <nb-option [value]="p.id">
                  {{ p.name }}
                </nb-option>
              }
            </nb-select>
          </div>

          <!-- COMMENTS -->
          <div class="form-field">
            <label for="comments">{{ 'Comment' | translate }}</label>
            <textarea
              nbInput
              id="comments"
              type="text"
              formControlName="comments"
              fullWidth
              (blur)="autoSave('comments')"
            ></textarea>
          </div>

        </div>
      </nb-card-body>
      @if (!priceSheet && anyFieldValueChanged()) {
        <nb-card-footer class="asset price-sheet-footer">
          <button nbButton type="submit" [disabled]="!isFormValid()">
            {{ "Add a pricesheet" | translate }}
          </button>
        </nb-card-footer>
      }
    </nb-card>
  </form>
}

